import './bootstrap'
import Vapor from 'laravel-vapor'
import { useGlobalStore } from '@stores/global'
import { createApp } from 'vue/dist/vue.esm-bundler'
import { createPinia } from 'pinia'
import router from './router'
import clickOutside from '@directives/clickOutside'

window.Vapor = Vapor

const pinia = createPinia()
const app = createApp({})
app.use(pinia)
app.use(router)
const global = useGlobalStore()

app.directive('click-outside', clickOutside)

global.setup()

/* Mount App */
app.mount('#fatalfury')
